module.exports = __webpack_public_path__ + "img/6质量管理体系认证证书.17b1e5e9.jpg";